
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";
import AssessmentModel from "@/models/createTicket/AssessmentModel";
import AssessmentSaveModel from "@/models/createTicket/AssessmentSaveModel";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,

        ValidationObserver,
        ValidationProvider,
        TextFloating,
    },
})
export default class ListNotification extends Vue {
    cekDesc() {
        if (this.ticket1.issue_description !== "") {
          this.isActiveDesc = true;
        } else if (this.ticket1.issue_description === "") {
          this.isActiveDesc = false;
        }
    }
    cekCause() {
        if (this.ticket1.root_cause !== "") {
          this.isActiveCause = true;
        } else if (this.ticket1.root_cause === "") {
          this.isActiveCause = false;
        }
    }
    submitTicket() {
        // return new Promise((resolve, reject) => {
            api.ticket
                .saveAssessment(this.ticket1)
                .then((response) => {

                  if (response.data.code === 200) {
                    this.$router.push({ name: "ticket" });
                  } else {
                    this.$swal("Peringatan", response.data.message, "warning");
                  }
                    // if (response.data.code === 200) {
                    //     this.ticket = Object.assign({}, response.data.data);
                    //     resolve(response);
                    // }
                })
                // .catch((err: any) => {
                //     reject(err);
                //     this.$swal("Error", err?.response?.data?.message, "error");
                // });
        // });
    }
    mounted() {
        this.getDetailTicket(this.$route.params.id);
        this.getWorkorder(this.$route.params.id);
    }
    utils = utils;
    titlePage = "Assessment Report";
    date = "21/JAN/2022";
    time = "12.30";
    title = "Cake Engine Breaking Down";
    subTitle = "Lorem Ipsum is simply text";
    status = "new";
    isOpen = "0";
    // ticket1: AssessmentModel = new AssessmentModel();
    isActiveDesc = false;
    isActiveCause = false;

    listImage: AttachmentModel[] = [];
    ticket: AssessmentModel = new AssessmentModel();
    ticket1: AssessmentSaveModel = new AssessmentSaveModel();
    ticket2: WorkorderModel = new WorkorderModel();
    attachment:any =  [];

    readonly: boolean = false;
    
    getDetailTicket(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getAssessment(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket = Object.assign({}, response.data.data);
                        this.ticket1.work_orders_id = this.ticket.work_orders_id;
                        this.ticket1.root_cause = this.ticket.root_cause;
                        this.ticket1.issue_description = this.ticket.issue_description;
                        // this.ticket1.attachment = [...this.ticket.attachments];
                        this.attachment = this.ticket.attachments;
                        if(this.ticket.issue_description !== null){ 
                            this.readonly = true;
                        }
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    getWorkorder(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket2 = Object.assign({}, response.data.data);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
        
    }

    addUploadImgRow() {
        const image = {path:null, label:null};
        this.ticket1.attachment.push(image);
    }
    removeUploadRow(i: number) {
        this.ticket1.attachment.splice(i, 1);
    }
    get colorStatus() {
        if (this.ticket.workorder.status === "new") {
            return "cl-red";
        } else {
            return "cl-green-light";
        }
    }
    get pitaStatus() {
        if (this.ticket.workorder.status === "new") {
            return "new";
        } else {
            return "on-progress";
        }
    }
}

